import { IConversion, ICustomAlert, IDuplicateConversions, IFeed_Alert } from "../../dashboard/alerts/alerts";

type AlertItem =
  | { type: 'duplicate'; data: [orderRef: string, conversions: IConversion[]] }
  | { type: 'feed'; data: IFeed_Alert }
  | { type: 'custom'; data: ICustomAlert }

export function prepareChunks(
  duplicates: IDuplicateConversions,
  feeds: IFeed_Alert[],
  customs: ICustomAlert[]
): AlertItem[][] {
  const maxHeight = 960
  const chunked: AlertItem[][] = []
  let currentChunk: AlertItem[] = []
  let currentHeight = 0

  const pushItem = (item: AlertItem, height: number) => {
    if (currentHeight + height > maxHeight) {
      chunked.push(currentChunk)
      currentChunk = []
      currentHeight = 0
    }
    currentChunk.push(item)
    currentHeight += height
  }

  for (const entry of Object.entries(duplicates)) {
    const l = entry[1].slice(0,5).length * 55
    
    pushItem({ type: 'duplicate', data: entry }, l)
  }

  for (const feed of feeds) pushItem({ type: 'feed', data: feed }, 115)
  for (const custom of customs) pushItem({ type: 'custom', data: custom }, 115)
  

  if (currentChunk.length > 0) chunked.push(currentChunk)

  return chunked
}